var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pwd-notice-top-main" }, [
    _c("p", [
      _vm._m(0),
      _c("span", { staticClass: "important mr-10" }, [
        _vm._v(_vm._s(_vm.$t("pdwComplexity.important"))),
      ]),
      _c("span", {
        domProps: { innerHTML: _vm._s(_vm.$t("pdwComplexity.topTips")) },
      }),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "mr-10" }, [
      _c("i", { staticClass: "el-icon-info" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }